import { useTranslation } from "react-i18next";
import { NormalizedTopic } from "~/types/search.types";
import { Language } from "~/providers/LanguageProvider";

import CheckboxSmall from "~/ui/Checkbox/CheckboxSmall";
import LoadingSpinner from "~/ui/LoadingSpinner/LoadingSpinner";

import { useTopicStore } from "~/stores";

interface ITopicItem {
    topic: NormalizedTopic;
    btnClickCallback: (isSelected: boolean, item: NormalizedTopic) => void;
}

const TopicItem = (props: ITopicItem) => {
    // Store methods
    const isTopicSelected = useTopicStore(state => state.isTopicSelected);

    const { topic, btnClickCallback } = props;
    
    const { i18n } = useTranslation();
    const language = i18n.language as Language;
    const topicName = topic?.label[language];
    const isSelected = isTopicSelected(topic.exploreId);
    const itemCount = topic.count >= 0 ? topic.count : <LoadingSpinner className="!text-stone-darker w-4 h-4" />;

    return (
        <div
            className="flex items-center justify-between gap-2 w-full rounded text-sm text-stone-darkest font-medium-light tracking-[-0.28px] rounded hover:bg-stone-lighter"
        >
            <CheckboxSmall
                className="flex items-center w-full h-9 text-sm text-stone-darkest font-medium-light tracking-[-0.28px] hover:text-stone-darkest gap-x-2"
                aria-labelledby={topicName ?? ""}
                onChange={(isSelectedValue) => btnClickCallback(isSelectedValue, topic)}
                isSelected={isSelected}
            >
                {topicName}
            </CheckboxSmall>

            <div className="pr-4">
                {itemCount}
            </div>
        </div>
    );
}

export default TopicItem;
